import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-card-selector',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './card-selector.component.html',
  styleUrl: './card-selector.component.css'
})
export class CardSelectorComponent {
  @Output() onClickCard = new EventEmitter();
  @Input() selected:boolean = false;
}
